import React, { useContext, useEffect, useState } from "react";
import { Layout, Avatar, Dropdown, Menu, Space } from "antd";
import {
  SettingOutlined,
  LogoutOutlined,
  DatabaseOutlined,
  CustomerServiceOutlined,
  SecurityScanOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { LanguageContext } from "../LanguageContext";

const { Header, Content, Footer } = Layout;

const AppLayout = ({ children }) => {
  const { language, translations } = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [userName, setUserName] = useState("Admin");
  const [activeButton, setActiveButton] = useState("");

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("admineditableList"))        setActiveButton("konfig");
    else if (path.includes("supportadmin"))         setActiveButton("kyt");
    else if (path.includes("adminuserrolecontrol")) setActiveButton("role");
    else setActiveButton("");
  }, [location]);

  useEffect(() => {
    const fetchUserName = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) return;
      try {
        const res = await fetch(
          `https://json-configrator-api.root.myoctoopidev.com/User/GetById/${userId}`
        );
        const data = await res.json();
        setUserName(data?.data?.name || "Admin");
      } catch {
        console.error("Kullanıcı bilgisi alınamadı");
      }
    };
    fetchUserName();
  }, []);

  const userMenu = (
    <Menu>
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        danger
        onClick={() => {
          localStorage.removeItem("userId");
          localStorage.removeItem("authToken");
          navigate("/login");
        }}
      >
        {translations[language].exit}
      </Menu.Item>
    </Menu>
  );

  const navBtnStyle = (key) => ({
    height: 36,
    borderRadius: 6,
    fontWeight: 500,
    fontSize: 14,
    border: 'none',
    background: activeButton === key
      ? 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)'
      : 'rgba(255,255,255,0.1)',
    color: '#fff',
    boxShadow: activeButton === key ? '0 4px 12px rgba(24,144,255,0.35)' : 'none',
    cursor: 'pointer',
    padding: '0 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  });

  return (
    <Layout style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Header
        style={{
          background: "#001529",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 30px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {/* Sol: Logo + Başlık */}
        <div
          style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
          onClick={() => navigate("/adminuserrolecontrol")}
        >
          <div style={{
            width: 34, height: 34, borderRadius: "50%",
            background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 4px 10px rgba(24,144,255,0.4)",
          }}>
            <SettingOutlined style={{ color: "#fff", fontSize: 16 }} />
          </div>
          <span style={{ color: "#fff", fontSize: 17, fontWeight: 600 }}>
            {translations[language].layoutTitle}
          </span>
        </div>

        {/* Sağ: Nav + Avatar */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button style={navBtnStyle("konfig")} onClick={() => navigate("/admineditableList")}>
            <DatabaseOutlined /> {translations[language].konfig}
          </button>
          <button style={navBtnStyle("kyt")} onClick={() => navigate("/supportadmin")}>
            <CustomerServiceOutlined /> {translations[language].kyt}
          </button>
          <button style={navBtnStyle("role")} onClick={() => navigate("/adminuserrolecontrol")}>
            <SecurityScanOutlined /> Kullanıcı Yönetimi
          </button>

          <Dropdown overlay={userMenu} placement="bottomRight">
            <Space style={{ cursor: "pointer", marginLeft: 8 }}>
              <Avatar style={{
                background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
                boxShadow: "0 2px 8px rgba(24,144,255,0.4)",
                fontWeight: 600,
              }}>
                {userName?.charAt(0).toUpperCase()}
              </Avatar>
              <span style={{ color: "#fff", fontWeight: 500, fontSize: 14 }}>{userName}</span>
            </Space>
          </Dropdown>
        </div>
      </Header>

      <Content style={{ padding: "20px", flex: 1, overflow: "auto", background: "#f0f2f5" }}>
        {children}
      </Content>

      <Footer style={{
        textAlign: "center",
        background: "#fff",
        borderTop: "1px solid #f0f0f0",
        padding: "12px",
        fontSize: 13,
        color: "#8c8c8c",
      }}>
        © 2026{" "}
        <a href="http://octoopi.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#1890ff" }}>
          Octoopi
        </a>{" "}
        &amp; by{" "}
        <a href="https://mertech.com.tr/" target="_blank" rel="noopener noreferrer" style={{ color: "#1890ff" }}>
          Mertech Electronics
        </a>
      </Footer>
    </Layout>
  );
};

export default AppLayout;
